import React from 'react';
import './JobDetailsFileListWithManifest.scss';
import JobAudioFileList from './JobAudioFileList';
import {
	JobUploadFileListWithManifest,
	PendingJobUploadFile
} from '../../store/selectors/jobsSelectors';
import { JobAudioUploadProgressBar } from './JobAudioUploadProgressBar';
import { CallDetails } from '../../models/dto/call';
import checkmarkIcon from '../../imgs/icons/checkmark.svg';
import { CallAudioUploadFailure } from '../../store/state/callAudioUploadState';

export default function JobDetailsFileListWithManifest(props: { jobId: number; fileList: JobUploadFileListWithManifest; }) {
	const fileList = props.fileList;
	
	return (
		<div className="job-details-file-list-with-manifest__file-list-container">

			{/*WAITING*/}
			<div className="job-details-file-list-with-manifest__file-list">
				<h3 className="h3-mb-2">Waiting for the following files ({fileList.pending.length.toLocaleString()})</h3>
				<div className="text-small text-light mb-4">This list is based on the call log you uploaded</div>
				<JobAudioFileList<PendingJobUploadFile> header="File name" files={fileList.pending} getFilename={c => c.call.fileName ?? ''} >
					{(f) => (
						<div key={f.call.id} className="boxed-list__item boxed-list__item_small-text">
							<div>{f.call.fileName}</div>

							{!!f.upload && f.upload.status === 'queued' && <div className="text-small text-light">Pending...</div>}

							{!!f.upload && (f.upload.status === 'uploading' || f.upload.status === 'finishing') &&
							<div className="mt-1">
								<JobAudioUploadProgressBar jobId={props.jobId} callIdentifier={f.upload.callIdentifier} isComplete={f.upload.status === 'finishing'} />
							</div>
							}
						</div>
					)}
				</JobAudioFileList>
			</div>

			{/*UPLOADED*/}
			<div className="job-details-file-list-with-manifest__file-list">
				<h3 className="h3-mb-2">Files successfully uploaded to Creovai ({fileList.uploaded.length.toLocaleString()})</h3>
				<div className="text-small text-light mb-4">These files have been submitted to Creovai</div>
				<JobAudioFileList<CallDetails> header="File name" files={fileList.uploaded} getFilename={c => c.fileName ?? ''} >
					{(c) => (
						<div key={c.id} className="boxed-list__item boxed-list__item_small-text">
							<div className="flex flex-align-center">
								<div className="flex-item-growing-shrinking">{c.fileName}</div>
								<div className="flex-item-static">
									<img src={checkmarkIcon} className="job-details-file-list-with-manifest__checkmark" alt="Checkmark" />
								</div>
							</div>
						</div>
					)}
				</JobAudioFileList>
			</div>

			{/*FAILED*/}
			{!!fileList.failed.length &&
			<div className="job-details-file-list-with-manifest__file-list">
				<h3 className="h3-mb-2">Files with issues ({fileList.failed.length.toLocaleString()})</h3>
				<div className="text-small text-light mb-4">These files were not uploaded due to problems</div>
				<JobAudioFileList<CallAudioUploadFailure> header="File name" files={fileList.failed} getFilename={c => c.filename ?? ''} >
					{(f, i) => (
						<div key={i} className="boxed-list__item boxed-list__item_small-text">
							<div className="text-red">{f.filename}</div>
							<div className="mt-1">{f.description}</div>
						</div>
					)}
				</JobAudioFileList>
			</div>
			}
		</div>
	);
}
